import React from "react";
import { Title } from "react-head";
import { Link } from "react-router-dom";
import * as Sentry from "@sentry/react";

export default function NotFound() {
  Sentry.captureMessage("NotFound");
  return (
    <div className="lm-layout-wrapper">
      <Title>Analytics for Law Firm</Title>
      <header className="lm-layout-header">
        <div className="pagewrapper">
          <div className="lm-layout-header-details">
            <Link to="/">Back to Litigation Analytics</Link>
            <h1>Not Found</h1>
          </div>
        </div>
      </header>
      <div className="lm-layout-content">
        <div className="pagewrapper">Nothing to see here!</div>
      </div>
    </div>
  );
}
